const imageExtensions = 'JPG, PNG, WebP';

const videoExtensions = 'MP4, MOV, AVI, WebM';

const imageAccept = 'image/jpeg,image/png,image/webp';

const videoAccept = 'video/mp4,video/quicktime,video/x-msvideo,video/webm';

const MAX_FILE_SIZE_MB = 10;

const TOOL_ID = 'gen-ai';

const FOLDER_NAME = 'GenAI';

const MINIAPP_PACKAGE_ID = 'com.picsart.genai-studiov2';

const MINIAPP_PACKAGE_IDS = {
  REPORTING: 'com.picsart.social.reporting',
  INVITATION: 'com.picsart.social.invitation-screen',
  EXPORT_SHARE: 'com.picsart.edit.export-and-share',
  SOCIAL_SHARE: 'com.picsart.edit.social-share',
};

const subscriptionToolId = 'genai-studio-v2-generic';

const DANCE_FLOW_ID =
  import.meta.env.VITE_DANCE_FLOW_ID || '6a69f7a3e1d4770cff2a52a4';

const DANCE_SECTION_SLUG = 'ai-dance-generator';

export {
  imageExtensions,
  videoExtensions,
  imageAccept,
  videoAccept,
  MAX_FILE_SIZE_MB,
  TOOL_ID,
  FOLDER_NAME,
  MINIAPP_PACKAGE_ID,
  MINIAPP_PACKAGE_IDS,
  subscriptionToolId,
  DANCE_FLOW_ID,
  DANCE_SECTION_SLUG,
};
